import { render } from "./Footer.vue?vue&type=template&id=227fe599&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=227fe599&scoped=true&lang=css"

import exportComponent from "C:\\Users\\absan\\Documents\\GitHub\\Starport\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227fe599"]])

export default __exports__